import { Controller } from "@hotwired/stimulus"

// This controller is used to update the page size and then reloads the page or turbo frame.
export default class extends Controller {
  static get values() {
    return { path: String, setting: String, turboFrame: String }
  }

  update(event) {
    const self = this

    fetch(this.pathValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({
        user: { [self.settingValue]: event.target.value },
      }),
      credentials: "same-origin",
    }).then(() => {
      if (self.hasTurboFrameValue) {
        document.querySelector(`turbo-frame#${self.turboFrameValue}`).reload()
      } else {
        location.reload()
      }
    })
  }
}
